import { Vector, str } from "scale-ts"

export const docs = Vector(str)
